const loginEn = {
  //登录公用
  loginCommon: {
    登录: 'Login',
    请选择: 'Please select',
    请输入登录邮箱与密码: 'Please enter your login email and password',
    账号: 'Account',
    请输入账号: 'Please enter your account',
    密码: 'Password',
    请输入密码: 'Please enter your password',
    记住密码: 'Remember the password',
    我已阅读并同意: 'I have read and agree to the ',
    隐私协议: 'Privacy Agreement',
    登录中: 'Loginning',
    请确认已阅读并同意隐私协议: 'Please confirm that you have read and agree to the Privacy Agreement',
    智慧储能云平台: 'EMS Cloud Platform',
    '驰硕-智慧储能云平台': 'ChiShuo-EMS Cloud Platform',
    '浙江明度-工商业储能云平台': '浙江明度-工商业储能云平台',
    '赛唯E宝 工商业储能云平台': 'SAV Energy Storage Cloud Platform',
    STE智慧储能云: 'Santie Intelligent Energy Storage Cloud Platform',
    '云基慧-智慧储能云平台': 'Ujoinwe-Intelligent Energy Storage Cloud Platform',
    工商业储能数据云平台: 'Industrial and commercial energy storage data cloud platform',
    智慧储能管控平台: 'Intelligent energy storage cloud platform',
    提示: 'Hint',
    '您的账号已到期，请联系管理员！': 'Your account has expired, please contact the administrator!',
    取消: 'Cancel',
    确定: 'Confirm'
  },
  //默认登录
  loginDefault: {
    智慧储能云平台: 'EMS Cloud Platform'
  },
  //驰硕登录
  LoginChiShuo: {
    '驰硕-智慧储能云平台': 'ChiShuo-EMS Cloud Platform'
  },
  //浙江明度登录
  LoginMingDu: {
    '浙江明度-工商业储能云平台': '浙江明度-工商业储能云平台'
  },
  //赛唯登录
  LoginMingDu: {
    '赛唯E宝 工商业储能云平台': 'SAV Energy Storage Cloud Platform'
  },
  //三铁登录
  LoginSanTie: {
    STE智慧储能云: 'Santie Intelligent Energy Storage Cloud Platform'
  },
  LoginUjoinWe: {
    '云基慧-智慧储能云平台': '云基慧-智慧储能云平台'
  },
  LoginWincle: {
    工商业储能数据云平台: 'Industrial and commercial energy storage data cloud platform'
  },
  //大力
  LoginDaLi: {
    智慧储能管控平台: 'Intelligent energy storage cloud platform'
  }
}
export default loginEn
